import styles from './SectionProgress.module.css';

interface SectionProgressProps {
    current: number;
    total: number;
}

export function SectionProgress({ current, total }: SectionProgressProps) {
    const percentage = total > 0 ? Math.round((current / total) * 100) : 0;

    return (
        <div className={styles.wrapper} role="progressbar" aria-valuenow={current} aria-valuemin={1} aria-valuemax={total}>
            <div className={styles.label}>
                <span className={styles.text}>Seccion {current} de {total}</span>
                <span className={styles.pct}>{percentage}%</span>
            </div>
            <div className={styles.track}>
                <div
                    className={styles.fill}
                    style={{ width: `${percentage}%` }}
                />
            </div>
        </div>
    );
}
